// The SPA's half of upstream's `HttpErrorInterceptor`: the alert every failed request raises, on
// every screen. `packages/api` decides WHICH failures count (`request.ts`); this draws them.
//
// ⚠️ IT WAS MISSING ENTIRELY, so a server error on any screen was silent — the button did nothing
// and nothing said why. Found 28 Oct comparing the Exchange dialog with upstream: made-up
// credentials answer HTTP 500, and upstream shows this where the port showed nothing.
import { useEffect, useState, type ReactElement } from 'react'
import { onRequestFailure } from '@woo-ext/api'
import { MessageDialog } from '@woo-ext/ui'

/** `HttpErrorInterceptor.genericError`, verbatim. */
export const GENERIC_REQUEST_ERROR =
  "Sorry, we've encountered a network error. Please check if your network is down or try again. Thank you."

/**
 * `alerts.error(message)` → `$rootScope.showAlert(message, 'Close', 'md')`. Failures that arrive
 * while one is showing queue behind it, as uib's stacked modals close one at a time.
 */
export function RequestFailureAlert(): ReactElement | null {
  const [queue, setQueue] = useState<string[]>([])

  useEffect(() => {
    onRequestFailure((failure) => {
      setQueue((previous) => [...previous, failure.message ?? GENERIC_REQUEST_ERROR])
    })
    return () => {
      onRequestFailure(undefined)
    }
  }, [])

  const current = queue[0]
  if (current === undefined) return null
  return (
    <MessageDialog
      text={current}
      okLabel="Close"
      size="md"
      onOk={() => {
        setQueue((previous) => previous.slice(1))
      }}
    />
  )
}
